import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './NotificationMenu.css';

const NotificationMenu = ({
    notifications = [],
    onMarkAllRead,
    onMarkAsRead,
    onClearAll,
    isOpen,
    onToggle
}) => {
    const menuRef = useRef(null);
    const history = useHistory();

    const unreadCount = notifications.filter(n => !n.isRead).length;

    const handleNotificationClick = (notification) => {
        // Mark as read immediately on click
        if (onMarkAsRead && !notification.isRead) {
            onMarkAsRead(notification.id);
        }

        const reportId = notification.metadata && notification.metadata.reportId;
        if (reportId) {
            history.push(`/reports/${reportId}`);
            onToggle();
        } else if (notification.type === 'report' || notification.message.toLowerCase().includes('report')) {
            history.push('/reports');
            onToggle();
        }
    };

    const getNotificationIcon = (notification) => {
        const type = notification.type;
        const msg = notification.message.toLowerCase();

        if (notification.metadata && notification.metadata.reportId || msg.includes('report')) {
            return 'assessment';
        }

        switch (type) {
            case 'output_connect': return 'link';
            case 'output_disconnect': return 'link_off';
            case 'output_blocked': return 'block';
            case 'guid_copy': return 'content_copy';
            case 'stream_stopped': return 'stop_circle';
            case 'set_designated': return 'star';
            default: return 'notifications';
        }
    };

    const formatTimestamp = (date) => {
        const d = new Date(date);
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="notification-menu-wrapper" ref={menuRef}>
            <div className="notification-bell-container" onClick={onToggle}>
                <i className="material-icons bell-icon">notifications</i>
                {unreadCount > 0 && <span className="unread-dot"></span>}
            </div>

            {isOpen && (
                <div className="notification-dropdown">
                    <div className="notification-dropdown-header">
                        <span>Notifications</span>
                        <div className="header-actions">
                            {notifications.length > 0 && (
                                <button
                                    className="action-link"
                                    onClick={onMarkAllRead}
                                    disabled={unreadCount === 0}
                                >
                                    Mark all as read
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="notification-list">
                        {notifications.length === 0 ? (
                            <div className="empty-notifications">
                                <i className="material-icons">notifications_none</i>
                                <p>No notifications yet</p>
                            </div>
                        ) : (
                            notifications.map(notification => (
                                <div
                                    key={notification.id}
                                    className={`notification-item ${!notification.isRead ? 'unread' : ''}`}
                                    onClick={() => handleNotificationClick(notification)}
                                >
                                    <div className="notification-icon-wrapper">
                                        <i className="material-icons">{getNotificationIcon(notification)}</i>
                                    </div>
                                    <div className="notification-item-content">
                                        <div className="notification-msg">{notification.message}</div>
                                        <div className="notification-time">{formatTimestamp(notification.timestamp)}</div>
                                    </div>
                                    {!notification.isRead && <div className="item-unread-indicator"></div>}
                                </div>
                            ))
                        )}
                    </div>

                    {notifications.length > 0 && (
                        <div className="notification-dropdown-footer">
                            <button className="clear-all-btn" onClick={onClearAll}>Clear All</button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default NotificationMenu;
